import { Dictionary } from "flow/api/types";

const translationTable: Dictionary = {
    sv: "sv-SE",
    en: "en-GB"
};

function getCultureFromPage() {
    const rawLang = document.documentElement.lang || "en";
    return translationTable[rawLang] || rawLang;
}

const collator = Intl.Collator(getCultureFromPage());

export function stringCompareAscend(a: string, b: string): number {
    return collator.compare(a, b);
}

export function stringCompareDescend(a: string, b: string): number {
    const result = collator.compare(a, b);
    if (result === 0) {
        return 0; // Avoid -0
    }
    return -result;
}
